import request from "../../../utils/request";

/**
 * 获取列表
 * @param params
 * @returns {AxiosPromise}
 */
export function getProductPageList(params){
    return request({
        url: '/sys/product/table',
        method: 'get',
        params
    })
}

/**
 * 获取列表
 * @returns {AxiosPromise}
 */
export function getProductList(params){
    return request({
        url: '/sys/product/list',
        method: 'get',
        params
    })
}

/**
 * 获取详情
 * @param params
 * @returns {AxiosPromise}
 */
export function getProductDetail(params){
    return request({
        url: '/sys/product/detail',
        method: 'get',
        params
    })
}


/**
 * 新增
 * @param params
 * @returns {AxiosPromise}
 */
export function saveProduct(data){
    return request({
        url: '/sys/product/save',
        method: 'post',
        data
    })
}

/**
 * 启停
 * @param params
 * @returns {AxiosPromise}
 */
export function enabledProduct(data){
    return request({
        url: '/sys/product/enabled',
        method: 'put',
        data
    })
}

/**
 * 删除
 * @param params
 * @returns {AxiosPromise}
 */
export function delProduct(params){
    return request({
        url: '/sys/product/del',
        method: 'delete',
        params
    })
}


/**
 * 授权
 * @param params
 * @returns {AxiosPromise}
 */
export function authProduct(data){
    return request({
        url: '/sys/product/auth',
        method: 'put',
        data
    })
}